import React, { createContext, useState, useEffect } from 'react';
import currencies from '../constants/currencies.json';

export const BusinessContext = createContext();

const API_URL = process.env.REACT_APP_API_URL;

export const BusinessProvider = ({ children }) => {
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState('');

  // Fetch the initially selected business on context mount
  useEffect(() => {
    const fetchSelectedBusiness = async () => {
      try {
        const response = await fetch(`${API_URL}/users/selected_business`, {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          setSelectedBusiness(data || null);
        }
      } catch (error) {
        console.error('Error fetching initial business:', error);
      }
    };

    fetchSelectedBusiness();
  }, []);

  // Update currency symbol when selectedBusiness changes
  useEffect(() => {
    if (selectedBusiness && selectedBusiness.currency) {
      const currencyData = currencies[selectedBusiness.currency];
      setCurrencySymbol(currencyData ? currencyData.symbol_native : '');
    } else {
      setCurrencySymbol('');
    }
  }, [selectedBusiness]);

  const updateSelectedBusiness = (business) => {
    setSelectedBusiness(business);
  };

  return (
    <BusinessContext.Provider value={{ selectedBusiness, updateSelectedBusiness, currencySymbol }}>
      {children}
    </BusinessContext.Provider>
  );
};
